import styled from "@emotion/styled";
import type { FC, ReactElement } from "react";

const Row = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.25rem;
  padding: 1rem;

  &:not(:last-child) {
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 1rem;
      right: 0;
      height: 1px;
      background-color: var(--color-gray-lighter, #e6e3db);
    }
  }

  @media screen and (min-width: 768px) {
    padding: 1.5rem;
  }
`;

const Column = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  gap: 0.375rem;

  @media screen and (min-width: 768px) {
    gap: 0.625rem;
  }
`;

const Title = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

interface LabListRowProps {
  label: string;
  icon: ReactElement;
  secondaryText?: string;
}

const LabListRow: FC<LabListRowProps> = ({ label, icon, secondaryText }) => (
  <Row>
    <Column>
      {icon}
      <Title className="m0 strong">{label}</Title>
    </Column>
    {secondaryText && <small className="m0 color-c-60">{secondaryText}</small>}
  </Row>
);

export default LabListRow;
